// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --headerHeight:4rem;
  --headerHeightMobile:calc(var(--headerHeight)*0.8);
}

:root{
  --headerRightWidthXL:46.5rem;
  --headerRightWidthDefault:7.5rem;
  --sideNavToggleWidth:2rem;
  --logoContainerWidth:4.25rem;
  --courtSystemContainerWidth:15.25rem;
  --userAccountWidthXL:12rem;
}

.header-container{
  width:100%;
  background-color:#fff;
}

.header-container .header{
    height:4rem;
    padding:0 1rem;
    background:#fff;
  }

.header-container .header__left{
      float:left;
      display:flex;
      align-items:center;
      width:calc(100% - 7.5rem);
      height:100%;
    }

.header-container .header__left .side-nav-toggle{
        display:inline-block;
        flex:0 0 auto;
        width:2rem;
      }

.header-container .header__left .logo{
        display:block;
        flex:0 0 auto;
        margin-right:1rem;
      }

@media (width <= 640px){

.header-container .header__left .logo{
          margin-left:1rem
      }
        }

.header-container .header__left .court-system-dropdown{
        display:flex;
        flex:0 0 15.25rem;
        flex-direction:row;
        flex-wrap:nowrap;
        align-content:stretch;
        align-items:center;
        justify-content:space-between;

        height:4rem;
      }

@media (width <= 640px){

.header-container .header__left .court-system-dropdown{
          display:none
      }
        }

.header-container .header__left .court-system-dropdown ftr-court-system-dropdown{
          width:100%;
        }

.header-container .header__left .main-menu{
        display:block;
        flex:1 0 auto;
        margin-left:1rem;
      }

.header-container .header__right{
      position:absolute;
      right:1rem;
      float:right;
      display:flex;
      gap:1rem;
      align-items:center;
      justify-content:flex-end;
      width:7.5rem;
      height:4rem;
      text-align:right;
    }

.header-container .header__right .user-dropdown{
        text-align:left;
      }

@media (width > 1230px){
      .header-container .header__left{
        width:calc(100% - 46.5rem);
      }

        .header-container .header__left .main-menu{
          width:calc(100% - 7.5rem);
        }

      .header-container .header__right{
        width:46.5rem;
      }

        .header-container .header__right .user-dropdown{
          width:12rem;
        }
    }

.header-container .breadcrumb{
    margin-left:1rem;
    background:#fff;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
